import { AppBar, Button, Grid, IconButton, Toolbar, Typography } from "@mui/material"
import { useHistory } from "react-router";
import { AuthStore, UserStore } from "../stores/AuthStore";
import React from "react";
import { jwtDecode } from "jwt-decode";
import { Call, Logout, MailOutline } from "@mui/icons-material";
import { useInjection } from "../di/ioc-provider";
import { IUserApiClient } from "../clients/userApiClient";
import { TYPES } from "../di/types";
export interface MainLayoutProps {
    children: any
}
export const MainLayout = (props: MainLayoutProps) => {

    var history = useHistory();
    const _userClient = useInjection<IUserApiClient>(TYPES.IUserClient);
    const apiKey = AuthStore.useState(w => w.authSettings.jwtToken);
    const authObj = AuthStore.useState(w => w.authSettings);
    const userDetail = UserStore.useState(w => w.user);
    if (apiKey == null || apiKey == '')
        history.push("/login");

    React.useEffect(() => {
        if (authObj.email == "" && authObj.name == "" && authObj.jwtToken != "" && authObj.jwtToken != null) {
            var info = jwtDecode(authObj.jwtToken) as any;
            var role = false;
            if (info.role != null) {
                role = info.role == "True";
            }
            AuthStore.update(w => { w.authSettings = { jwtToken: authObj.jwtToken, email: info.email, name: info.name, newUser: false, role: role } })

        }
    }, [authObj]);

    React.useEffect(() => {
        if (authObj.jwtToken != "" && authObj.jwtToken != null && userDetail == undefined) {

            _userClient.getUser().then((res) => {
                UserStore.update(w => { w.user = res.data });
            })
        }
    }, [userDetail, authObj]);
    return <>
        <AppBar position="static">
            <Toolbar style={{ backgroundColor: "#EDBB5F", boxShadow: "none" }}>
                <Grid container >
                    <Grid item xs={6}>
                        <Typography style={{ position: "relative", top: "8px" }} variant="h6" color="inherit" component="div">
                            ORZEON. WE CURE. WE PAY. - Documenten
                        </Typography>
                    </Grid>
                    <Grid item xs={6} container justifyContent={"space-between"}>
                        <Grid item>

                            <Button onClick={() => {
                                window.location.href = 'https://orzeon.be';
                            }} className="siteButton">Website</Button>
                        </Grid>
                        <Grid item>
                            <Typography style={{ position: "relative", top: "8px" }} variant="h6" color="inherit" component="div">
                                <MailOutline style={{ position: "relative", top: "4px" }} /> info@orzeon.be
                                <Call style={{ position: "relative", top: "4px", marginLeft: "8px" }} /> 0478 12 13 21
                                <IconButton onClick={() => {
                                    window.localStorage.removeItem("jwt");
                                    AuthStore.update(w => { w.authSettings.jwtToken = "" });
                                    history.push("/login");
                                }}><Logout /></IconButton>
                            </Typography>




                        </Grid>
                    </Grid>
                   
                </Grid>

            </Toolbar>
        </AppBar>
        <Grid container padding={5} style={{marginBottom:"14px"}}>

            {authObj.jwtToken != null ? <> {props.children}</> : <></>}


        </Grid>
        {/* <AppBar position="sticky" color="primary" sx={{ top: 'auto', bottom: 0 }}>
            <Toolbar style={{ backgroundColor: "#EDBB5F", boxShadow: "none" }}>
                <Grid container >

                </Grid>

            </Toolbar>
        </AppBar> */}
    </>
}